import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_FAC026_Request,
  IAPI_FAC026_Response
} from "../../../type/apiType";

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

// 施設転換後非加入参照
// API仕様書_施設
const httpAPI_FAC026 = async (
  param: IAPI_FAC026_Request
): Promise<IAPI_FAC026_Response> => {
  let res = await http.post(ApiUrl.API_FAC026, {
    ...param,
  });
  return res.data;
};
export { httpAPI_APP016, httpAPI_FAC026 };

